import React from 'react';
import {Link} from 'react-router-dom';

import {properties} from '../seed/data';

class UserProperty extends React.Component {
    constructor(props) {
        super(props);
    }
    renderList () {
        let userId = '123';
        return properties.map((p, i) => 
        <Link to={{pathname: `/user/${userId}/property/${i}`}} className="p-list-item-link" key={i}>
            <li className="p-list-item">
                <span className="p-list-item-address">{p.address}</span> <span className="badge badge-info">{p.room_count} Rm</span>
                <div className="p-list-item-price">${p.price}</div>
            </li>
        </Link>)
    }

    render () {
        return (
            <div className="container frame">
                <div className="col-md-8 offset-md-2">
                    <h4 className="flex-space-between">Property <Link className="btn btn-primary btn-sm" to={{pathname: '/property/new'}}>New</Link></h4>
                    <ul className="p-list">
                        {this.renderList()}
                    </ul>
                </div>
            </div>
        )
    }
}

export default UserProperty;